<template>
    <div>

        <div class="form-group">
            <label for="fullname">手机号</label>
            <input class="form-control" v-model="formValidate.phone" placeholder="请输入手机号" required>
        </div>
        <label for="emailaddress">验证码</label>
        <div class="input-group" style="margin-bottom:10px">
            <input type="text" class="form-control" v-model="formValidate.code" placeholder="请输入验证码">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="_getCode"
                    :disabled="disabled">{{codeBtn}}</button>
            </div>
        </div>
        <div class="form-group">
            <label for="emailaddress">授权码</label>
            <input class="form-control" v-model="formValidate.card" required placeholder="请输入您购买的授权码">
        </div>
        <div class="form-group">
            <label for="fullname">授权域名</label>
            <input class="form-control" v-model="formValidate.url" placeholder="请输入您要授权的域名" required>
        </div>
        <div class="alert alert-danger" role="alert">
            注意：授权顶级域名必须加www，授权www，可使用顶级域名，授权其他二级不可使用顶级域名
            <a href="javascript:;" @click="example">查看样例</a>
        </div>




        <div class="form-group mb-0 text-center">
            <button class="btn btn-primary btn-block" @click="_postOnline">立即授权
            </button>
        </div>
        <Modal v-model="modal" title="授权须知" >
            <p>本站为【极客轻商城系统】官方授权中心，授权需绑定手机号，请绑定自己常用的手机号，后续下载更新和更换授权都将用绑定的手机号进行鉴权</p>
           
            <p style="color:red">【极客轻商城系统】仅限在法律允许范围内使用；用户使用【极客轻商城系统】造成的一切后果与程序及程序作者无关；
                管理员有权对违法法律、涉嫌违规的网站进行解除授权；所有涉嫌色情/赌博/诈骗等包括但不限于此的违规网站，一经查实将解除授权
            </p>
            
        </Modal>
    </div>
</template>
<script>
    import {
        getCode,
        postOnline
    } from "@/api/index"
    export default {
        data() {
            return {
                codeBtn: "获取验证码",
                countdown: 120,
                disabled: false,
                formValidate: {
                    phone: "",
                    code: "",
                    card: "",
                    url: ""
                },
                modal:true
            }
        },
        methods: {
            //获取验证码
            _getCode() {
                var reg = /^1[3456789]\d{9}$/;
                var user = reg.test(this.formValidate.phone);
                if (!user) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写正确的手机号",
                    });
                }
                this.$Message.loading({
                    content: "获取中...",
                    duration: 2,
                });
                getCode({
                    phone: this.formValidate.phone
                }).then(res => {
                    if (res.code == 200) {
                        this.$Message.success({
                            background: true,
                            content: res.msg,
                        });
                        this.settime(120);
                    } else {
                        this.$Message.error({
                            background: true,
                            content: res.msg,
                        });
                    }
                })
            },
            //验证码
            settime(e) {
                //验证码动态
                if (this.countdown == 0) {
                    (this.codeBtn = "重新发送"),
                    (this.countdown = "120"),
                    (this.disabled = false);
                    return;
                } else {
                    (this.codeBtn = "重新发送(" + this.countdown + ")"),
                    (this.disabled = true);
                    this.countdown--;
                }
                setTimeout(() => {
                    this.settime(120);
                }, 1000);
            },
            // 授权
            _postOnline() {
                if (!this.formValidate.phone) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写正确的手机号",
                    });
                }
                if (!this.formValidate.code) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写验证码",
                    });
                }
                if (!this.formValidate.card) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写授权码",
                    });
                }
                if (!this.formValidate.url) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写域名",
                    });
                }
                postOnline({
                    phone: this.formValidate.phone,
                    code: this.formValidate.code,
                    card: this.formValidate.card,
                    url: this.formValidate.url,
                }).then(res => {
                    if (res.code == 200) {
                        this.$Message.success({
                            background: true,
                            content: res.msg,
                        });
                        this.$store.state.phone = this.formValidate.phone
                        this.$store.state.code = this.formValidate.code
                        this.$router.push('/down')
                    } else {
                        this.$Message.error({
                            background: true,
                            content: res.msg,
                        });
                    }
                })
            },
            // 查看样例
            example() {
                let cont =
                    "<p>1.如您要授权的域名为shop.example.com，则直接填写shop.example.com即可</p><p>2.如您要授权的域名为example.com，则需要填写www.example.com，授权成功后example.com和www.example.com都可以用</p>"
                this.$Modal.warning({
                    title: "授权域名规范",
                    content: cont
                });
            }

        },
    }
</script>

<style lang="less" scoped>

</style>